import {
  TransactionStatus,
  isPatientEClaimTransactionExtendedData,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../../transaction-action';
import { TransactionHelpers } from '../../../transaction-helpers';
import { EasyclaimTransactionExtendedData } from '../easyclaim-transaction';

export class ApproveEasyclaimTransaction
  implements ITransactionAction<EasyclaimTransactionExtendedData>
{
  icon = 'done';
  label = 'Approve';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isPatientEClaimTransactionExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<EasyclaimTransactionExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(
      data,
      isPatientEClaimTransactionExtendedData
    ).pipe(
      map((transaction) => {
        if (!transaction) {
          return false;
        }
        return transaction.status === TransactionStatus.Pending;
      })
    );
  }

  async do(
    data: ITransactionActionsData<EasyclaimTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.approve(
      data.invoice,
      data.latestTransaction,
      'Approve Medicare Claim'
    );
    this.inProgress$.next(false);
  }
}
